import {NavigateOptions, To, useNavigate} from 'react-router-dom';

const history = {
   push: (to: To, options?: NavigateOptions) => {
      console.warn('History.push is not defined', to);
   },
};

export function useSetHistoryPush() {
   const navigate = useNavigate();
   history.push = navigate;
}

export default history;
